export default function Footer({ content }) {
  const c = content || {};
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--ink)] text-[var(--bone)] py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-serif-display text-3xl">
            Elements <span className="italic text-[var(--bone-2)]">of Meaford</span>
          </p>
          <p className="mt-4 text-[var(--bone-2)] text-sm leading-relaxed max-w-md">
            {c.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-[var(--terracotta)]">Visit</p>
          <p className="mt-3 text-sm leading-relaxed text-[var(--bone-2)]">
            {c.address_line_1}
            <br />
            {c.address_line_2}
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-[var(--terracotta)]">Contact</p>
          <ul className="mt-3 space-y-2 text-sm text-[var(--bone-2)]">
            <li>
              <a
                href={`tel:${(c.phone || "").replace(/[^0-9+]/g, "")}`}
                className="hover:text-[var(--bone)] transition-colors"
                data-testid="footer-phone"
              >
                {c.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${c.email}`}
                className="hover:text-[var(--bone)] transition-colors"
                data-testid="footer-email"
              >
                {c.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[var(--bone-2)]/80">
        <span>&copy; {year} Elements Of Meaford</span>
        <span>Heritage District · Meaford, ON</span>
      </div>
    </footer>
  );
}
